import React, { useEffect, useLayoutEffect } from 'react'
import { DeleteFilled, EditFilled, FilterOutlined, InfoCircleTwoTone, PlusCircleFilled, PlusOutlined, SearchOutlined, SyncOutlined } from '@ant-design/icons';
import { Button, Card, Col, Flex, Input, message, Modal, Row, Select, Space, Table, Tooltip, Typography } from 'antd';
import { Pagination, Grid } from "@mui/material";
import Message from '../../Components/common/Message';
import AuthService from '../../Components/auth/AuthService';
import { encodeId, formatCurrency } from '../../Components/common/CommonFun';
import { useLoadingDispatch, showLoading, hideLoading } from "../../context/loadingContext";
import moment from 'moment';
import { styled } from '@mui/system';
import { Check } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { locationCategories, yesNo } from '../../Components/common/Constants';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { showMessage } from '../../Components/Utils/message';
import { EXPIRATION_TIME } from '../../Components/common/Constants';
import ProductInfoModal from '../../Components/Modals/ProductInfoModal';
const DataSheet = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;
const { Search } = Input;

const AntTable = styled('div')`
  .ant-table-tbody > tr > td {
    border-bottom: '1px solid #b7b9bd';
  }
`;

const Auth = new AuthService();

const ProductLocationList = () => {
  const { Text } = Typography;
  const { Option } = Select;
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const layoutDispatch = useLoadingDispatch()
  const { locations, products, aisles, roles, type: roleType} = useSelector((state) => state?.AppState?.userCreds);
      const canAccess =
        roleType === 0 ||
        roleType === 1 ||
        (roleType === 2 && roles?.some((role) => role.role_id === 4));

  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("");

  const [filters, setFilters] = React.useState(() => {
    const existing = localStorage.getItem('ProductLocationFilters');
    const parsed = existing ? JSON.parse(existing) : {};
    const currentTime = new Date().getTime();

    const defaultFilters = {
      selected_aisle: null,
      selected_location: null,
      selected_product: null,
      page: 1
    };

    if (parsed.timestamp && currentTime - parsed.timestamp < EXPIRATION_TIME) {
      return { ...defaultFilters, ...parsed };
    }
    localStorage.removeItem('ProductLocationFilters');
    return defaultFilters;
  });

  const updateFilters = (newValues) => {
    const existingString = localStorage.getItem('ProductLocationFilters');
    const existing = existingString ? JSON.parse(existingString) : {};

    Object.assign(existing, newValues);
    existing.timestamp = new Date().getTime();

    localStorage.setItem('ProductLocationFilters', JSON.stringify(existing));
  };

  const [totalPages, setTotalPages] = React.useState(0);
  const [limit] = React.useState(50);
  const [totalCount, setTotalCount] = React.useState(null);

  const [modalVisibleProduct, setModalVisibleProduct] = React.useState(false);
  const [selectedProductDetails, setSelectedProductDetails] = React.useState({
    totalStock: 0,
    code: '',
    name: '',
    productDetails: [],
    selectedRecord: null
  });

  // const [aisles, setAisles] = React.useState([]);
  // const [locations, setLocations] = React.useState([]);
  // const [products, setProducts] = React.useState([]);
  

  const [allProductLocations, setAllProductLocations] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const handleRowClick = (id) => {
        const hasedID = encodeId(id)

    navigate(`/product-locations/${hasedID}`)
  };

  const locationColumns = [
    
    
    {
      title: 'Aisle',
      render: (record) => {
        return record?.aisle_id ? aisles.find(obj => obj.id == record.aisle_id)?.title : '';
      }
    },
    // {
    //   title: 'Location',
    //   render: (record) => {
    //     return record?.location_id ? locations.find(obj => obj.id == record.location_id)?.title : '';
    //   }
    // },
    {
      title: 'Location',
      render: (record) => {
        if (record?.location_id) {
          const location = locations?.find(obj => obj.id == record?.location_id);
          if (location) {
            return `${location?.code}`; 
          }
        }
        return '';
      }
    },
    {
      title: 'Product',
      render: (record) => {
        if (record?.product_netsuite_id) {
          const product = products?.find(obj => obj.netsuite_id == record?.product_netsuite_id);
          if (product) {
            return (
              <Flex gap={5} align="center">
                <Tooltip title={'Product Info'}>
                  <InfoCircleTwoTone
                    style={{ fontSize: '22px', cursor: 'pointer', padding: '2px' }}
                    onClick={() => handleInfoClick(record)}
                  />
                </Tooltip>
                <span>{`${product?.code} - ${product?.name} `}</span>
              </Flex>
            );
          }
        }
        return '';
      }
    },
    {
      title: "Category",
      render(record) {
        const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);

        return (
          <span>{item ? `${item?.category}` : '-'}</span>
        )

      }
    },
    {
      title: "Sub Category",
      render(record) {
        const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);

        return (
          <span>{item ? `${item?.sub_category}` : '-'}</span>
        )

      }
    },
    
    // {
    //   title: 'Type',
    //   render: (record) => {
    //     return record?.type ? locationCategories.find(obj => obj.id == record.type).title : '';
    //   }
    // },
   
    {
      title: 'Action',
      key: 'action',
      align: "right",
      dataIndex: '',
      render(record) {
        return (
          <div style={{ display: 'flex', justifyContent: 'end'}} onClick={(e) => e.stopPropagation()}>
            <EditFilled  onClick={() => handleRowClick(record.id)}  style={{ fontSize: '25px', cursor: "pointer", marginRight: "5px", color: "#001529"}} />
            {canAccess && (
              <DeleteFilled style={
                  {
                    fontSize: "25px",
                    cursor: "pointer",
                    color: "#cd1437",
                }} onClick={() => {
                  Modal.confirm({
                    title: 'Delete Location',
                    centered: true,
                    content: `Are you sure you want to delete this location?`,
                    onOk:()=> deleteLocation(record.id),
                    okText: 'Delete',
                    cancelText: 'Cancel',
                    width: 600,
                    okButtonProps: { size: "large"  },
                    cancelButtonProps: { size: "large" },
                  });
                }} 
                />
            )}
            
          </div>
        );
      },
    },
  ];

  const deleteLocation = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/product-location/product-location`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        getAllProductLocations();
        showMessage('success',res?.message);
      } else {
        showMessage('error',res?.message);
      }
    } catch (err) {
      console.log(err);
      showMessage('error',err?.message);
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  const handleModalCancelProduct = () => {
    setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: '', name: '', productDetails: [], selectedRecord: null });
    setModalVisibleProduct(false);
  }

  const handleInfoClick = async (record) => {
    const product = products?.find((item) => item?.netsuite_id == record?.product_netsuite_id);
    showLoading(layoutDispatch)
    try {

      const res = await Auth.fetch(`/product/product-details?id=${record?.product_netsuite_id}`)
      if (res?.ack) {
        if (res?.product_details.length > 0) {
          const totalStock = res.product_details.reduce((sum, item) => sum + (Number(item.stock_level) || 0), 0);
          setSelectedProductDetails({ ...selectedProductDetails, totalStock: totalStock, code: product?.code, name: product?.name, productDetails: res?.product_details, selectedRecord: product });
          setModalVisibleProduct(true);
          hideLoading(layoutDispatch)

        } else {
          showMessage('error', 'No Details');
          hideLoading(layoutDispatch)
        }
      } else {
        setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: product?.code, name: product?.name, productDetails: [] });
        showMessage('error', res?.message)
        hideLoading(layoutDispatch)

      }

    } catch (error) {
      showMessage('error', 'something went wrong');
      hideLoading(layoutDispatch)
    }
  };
  

  const getAllProductLocations = async () => {
    showLoading(layoutDispatch)
    try {
      const res = await Auth.post(`/product-location/products-locations`, {
        limit: limit,
        page: filters.page,
        ...(filters?.selected_aisle && { aisle_id: filters.selected_aisle }),
        ...(filters?.selected_location && { location_id: filters.selected_location }),
        ...(filters?.selected_product && { product_netsuite_id: filters.selected_product })
      });
      if(res.ack) {
        setAllProductLocations(res.products_locations)
        setTotalPages(Math.ceil(res.total_count / limit));
        setTotalCount(res?.total_count);
      }  else {
        showMessage('error',res.message);
      }
    } catch (error) {
      console.log(error);
      showMessage('error',"Something went wrong");
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const handleChange = (event, value) => {
    setFilters(prev => ({ ...prev, page: value }));
    updateFilters({ page: value });
  }; 

  useEffect(()=> {
    getAllProductLocations()
   },[filters]);


  return (
    <DataSheet>
    <Card title={<><FilterOutlined style={{ color: '#6cb8ff'}}/> Product Picking Locations</>}
        style={{ marginBottom: '10px' }}
        extra={
          <>
          {canAccess && <PlusCircleFilled style={{ fontSize: "30px", color:"#006cb8"}}  onClick={()=> navigate('/product-locations/new')} />}
          </>
        }
      >
        <Row gutter={[6, 1]}>
          <Col xs={24} md={12} lg={4} xl={5}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Aisle</label>
            <Select
              style={{
                width: "100%",
              }}
              showSearch
              allowClear
              value={filters?.selected_aisle}
              placeholder="Aisle"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                setFilters({ ...filters, selected_aisle: value, page: 1 });
                updateFilters({ selected_aisle: value, page: 1 });
              }}
            >
              {aisles?.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item?.title}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} md={12} lg={4} xl={5}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Location</label>
            <Select
              style={{
                width: "100%",
              }}
              showSearch
              allowClear
              value={filters?.selected_location}
              placeholder="Location"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                setFilters({ ...filters, selected_location: value, page: 1 });
                updateFilters({ selected_location: value, page: 1 });
              }}
            >
              {locations?.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item?.code}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} md={12} lg={6} xl={5}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Product</label>
            <Select
              style={{
                width: "100%",
              }}
              showSearch
              allowClear
              value={filters?.selected_product}
              placeholder="Product"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                setFilters({ ...filters, selected_product: value, page: 1 });
                updateFilters({ selected_product: value, page: 1 });
              }}
            >
              {products?.map((item) => (
                <Option key={item.netsuite_id} value={item.netsuite_id}>
                  {`${item?.code} - ${item?.name} `}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} md={12} lg={6} xl={5}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Search</label>
            <Input
              placeholder="Search"
              // value={filters.batchCode}
              // onChange={(e) => setFilters(prev => ({ ...prev, batchCode: e.target.value }))}
            />
          </Col>
          <Col xs={24} md={12} lg={4} xl={4}>
            <Space style={{ width: '100%', marginTop: '25px' }}>
              <Button
                type="primary"
                icon={<SearchOutlined />}
              >
                Search
              </Button>
            </Space>
          </Col>
        </Row>
      </Card>
    {/* <div style={{ alignItems: 'center', marginBottom: 10, display: 'flex', justifyContent: 'space-between'}} >
        <h3 style={{ margin: 0}}>Product Picking Locations</h3>
        
          {canAccess && <PlusCircleFilled style={{ fontSize: "30px", color:"#006cb8"}}  onClick={()=> navigate('/product-locations/new')} />}

        </div>
   <Grid container rowSpacing={2} columnSpacing={1.5}>
   <Grid item xs={12} sm={6} md={3} lg={3} xl={2}>
          <label htmlFor="Aisle">Aisle</label>
          <Select
              style={{
                width: "100%",
              }}
              showSearch
              allowClear
              size="large"
              value={filteredLocations?.selected_aisle}
              placeholder="Aisle"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                setFilteredLocations({ ...filteredLocations, selected_aisle: value });
                setPage(1)
              }}
            >
              {aisles?.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item?.title}
                </Option>
              ))}
            </Select>
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={3} xl={2}>
          <label htmlFor="location">Location</label>
          <Select
              style={{
                width: "100%",
              }}
              showSearch
              allowClear
              size="large"
              value={filteredLocations?.selected_location}
              placeholder="Location"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                setFilteredLocations({ ...filteredLocations, selected_location: value });
                setPage(1)
              }}
            >
              {locations?.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item?.code}
                </Option>
              ))}
            </Select>
        </Grid>
       
        
        <Grid item xs={12} sm={6} md={3} lg={3} xl={2}>
          <label htmlFor="product">Product</label>
          <Select
              style={{
                width: "100%",
              }}
              showSearch
              allowClear
              size="large"
              value={filteredLocations?.selected_product}
              placeholder="Product"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                setFilteredLocations({ ...filteredLocations, selected_product: value });
                setPage(1)
              }}
            >
              {products?.map((item) => (
                <Option key={item.netsuite_id} value={item.netsuite_id}>
                  {`${item?.code} - ${item?.name} `}
                </Option>
              ))}
            </Select>
        </Grid>
       
      </Grid> */}
    
    <AntTable >
      <Table
          dataSource={allProductLocations}
          columns={locationColumns}
          style={{ overflowX: "auto" }}
          pagination={false}
          loading={isLoading}
          footer={() => {
            const startRecord = (filters.page - 1) * limit + 1;
            const endRecord = Math.min(filters.page * limit, allProductLocations?.length ? totalCount : 0); 
            return `Showing ${startRecord}-${endRecord} of ${allProductLocations?.length ? totalCount : "0"} Records`;
          }}
          rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
          scroll={{ x: 'max-content'}}
        />
      </AntTable>
      <div style={{ float: "right", margin: "10px" }}>
        <Pagination
          page={filters.page}
          count={totalPages}
          variant="outlined"
          color="primary"
          onChange={handleChange}
        />
      </div>
      <Message type={type} msg={loadMessage} />
      <ProductInfoModal
        visible={modalVisibleProduct}
        onCancel={handleModalCancelProduct}
        selectedItemDetails={selectedProductDetails}
        selectedItems={selectedProductDetails?.productDetails}
        selectedRecord={selectedProductDetails?.selectedRecord}
      />
    </DataSheet>
  )
}

export default ProductLocationList;
